import React from "react";
import { Component } from "react";
import { Switch } from "react-router-dom";
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation, chooseFontColor, translate } from "../../utils/useful";
import LoaderButton from "../LoaderButton";
import FixedView from "../FixedView";
import { nanoid } from "nanoid";
import SelectInput from "./SelectInput";
import Dropzone from "react-dropzone";
import FormViewer from "../FormViewer";
import SidebarView from "../SidebarView";
import { FormBuilderObjects } from "../../variables/formBuilderData";
import SwitchInput from "./SwitchInput";
import ParamsInput from "./ParamsInput";
import HttpServices from "../../utils/Http.services";

// import React, { useRef, useState } from "react";

class MainComponentFloatConfig extends Component {
  state = {


    fontsize: [
      // { type: 8 },
      // { type: 9 },
      // { type: 10 },
      // { type: 11 },
      { type: 12 },
      { type: 13 },
      { type: 14 },
      { type: 15 },
      { type: 16 },
      { type: 17 },
      { type: 18 },
      { type: 20 },
      { type: 24 },
      { type: 30 },
      { type: 36 },
      { type: 48 },
      // { type: 60 },
      // { type: 72 },
      // { type: 96 },
    ],

    fontWeights: [
      { lable: '{{lang}}Light', value: 300 },
      { lable: '{{lang}}Normal', value: null },
      { lable: '{{lang}}Semibold', value: 500 },
      { lable: '{{lang}}Bold', value: 600 },
      { lable: '{{lang}}Bolder', value: 700 },
      { lable: '{{lang}}Extra Bold', value: 800 },
    ],


    imageSourceOptions: [],
    sizesFields: [
      { key: 'style.width', type: 'NumberInput', col: '9', information: { label: '{{lang}}Image width', maxValue: 100, placeholder: '{{lang}}width', required: false }, },

      { key: 'style.widthUnit', type: 'SelectInput', col: '3', information: { label: '\u200B', placeholder: '{{lang}}select', defaultValue: '%', items: [{ title: '%', value: '%' }, { title: 'px', value: 'px' },], emptyNotAllowed: true } },

      { key: 'style.maxWidth', type: 'NumberInput', col: '9', information: { label: '{{lang}}Max width', maxValue: 100, placeholder: '{{lang}}width', required: false }, },

      { key: 'style.maxWidthUnit', type: 'SelectInput', col: '3', information: { label: '\u200B', placeholder: '{{lang}}select', defaultValue: '%', items: [{ title: '%', value: '%' }, { title: 'px', value: 'px' },], emptyNotAllowed: true } },

      { key: 'style.align', type: 'SelectInput', col: '12', information: { label: '{{lang}}Alignment', placeholder: '{{lang}}select', defaultValue: 'center', items: [{ title: '{{lang}}Left', value: 'left' }, { title: '{{lang}}Center', value: 'center' }, { title: '{{lang}}Right', value: 'right' }], emptyNotAllowed: true } },

      // { key: 'style.borderRadius', type: 'SidesInput', col: '12', information: { label: '{{lang}}Round corners', inputClass: 'none', placeholder: '{{lang}}Border radius' } },

      { key: 'style.margin', type: 'SidesInput', col: '12', information: { label: '{{lang}}Margin', inputClass: 'none', placeholder: '{{lang}}Margin' } },

      { key: 'style.padding', type: 'SidesInput', col: '12', information: { label: '{{lang}}Padding', inputClass: 'none', placeholder: '{{lang}}Padding' } },


    ],


    columnSettingsFields: [
      {
        key: 'style.width', type: 'NumberInput', col: '9', information: {
          label: '{{lang}}Column width', placeholder: '{{lang}}width',
          unit: { key: 'style.widthUnit', type: 'SelectInput', col: '3', information: { label: '{{lang}}unit', defaultValue: '%', type: 'local', items: [{ value: '%', title: '%' }, { value: 'px', title: 'px' }], emptyNotAllowed: true, placeholder: '{{lang}}select', required: true }, showMain: true },
          required: false
        },
      },

      // { key: 'style.widthUnit', type: 'SelectInput', col: '3', information: { label: '\u200B', placeholder: '{{lang}}select', defaultValue: '%', items: [{ title: '%', value: '%' }, { title: 'px', value: 'px' },], emptyNotAllowed: true } },

      {
        key: 'style.maxWidth', type: 'NumberInput', col: '9', information: {
          label: '{{lang}}Max width', placeholder: '{{lang}}width',
          unit: { key: 'style.maxWidthUnit', type: 'SelectInput', col: '3', information: { label: '{{lang}}unit', defaultValue: '%', type: 'local', items: [{ value: '%', title: '%' }, { value: 'px', title: 'px' }], emptyNotAllowed: true, placeholder: '{{lang}}select', required: true }, showMain: true },
          required: false
        },
      },

      // { key: 'style.maxWidthUnit', type: 'SelectInput', col: '3', information: { label: '\u200B', placeholder: '{{lang}}select', defaultValue: '%', items: [{ title: '%', value: '%' }, { title: 'px', value: 'px' },], emptyNotAllowed: true } },

      { key: 'style.align', type: 'SelectInput', col: '12', information: { label: '{{lang}}Alignment', placeholder: '{{lang}}select', defaultValue: 'start', items: [{ title: '{{lang}}Start', value: 'start' }, { title: '{{lang}}Center', value: 'center' }, { title: '{{lang}}End', value: 'end' }], emptyNotAllowed: true } },

      { key: 'style.borderRadius', type: 'SidesInput', col: '12', information: { label: '{{lang}}Round corners', inputClass: 'none', placeholder: '{{lang}}Border radius' } },

      { key: 'style.margin', type: 'SidesInput', col: '12', information: { label: '{{lang}}Margin', inputClass: 'none', placeholder: '{{lang}}Margin' } },

      { key: 'style.padding', type: 'SidesInput', col: '12', information: { label: '{{lang}}Padding', inputClass: 'none', placeholder: '{{lang}}Padding' } },

      { key: 'style.boxShadow', type: 'BoxShadowInput', col: '12', information: { label: '{{lang}}Box shadow', inputClass: 'none', } },

      { key: 'style.background', type: 'ColorInput', col: '12', information: { label: '{{lang}}Background color', } },

    ],


    actionHeader: [
      { key: 'type', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'view', value: 'view' }, { title: 'open window', value: 'openWindow' }], label: 'action', placeholder: 'Choose...', required: true } },
      {
        key: 'page', type: 'SelectInput', col: '12', information: { label: '{{lang}}pages', type: 'api', address: 'getFrames', filter: { type: 'page' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}pages', required: false }, showMain: false,
        dependencies: [{
          refKey: 'type',
          targetKey: 'page',
          conditions: {
            root: {
              id: 'root',
              action: 'or',
              conditions: {
                1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'openWindow' } },
                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
              }
            },
          },
          show: true,
          init: true,
        }],
      }

    ],

    colors: [
      '#F44336',
      '#FFEBEE',
      '#FFCDD2',
      '#EF9A9A',
      '#E57373',
      '#EF5350',
      '#F44336',
      '#E53935',
      '#D32F2F',
      '#C62828',
      '#B71C1C',
      '#FF8A80',
      '#FF5252',
      '#FF1744',
      '#D50000',
      '#E91E63',
      '#FCE4EC',
      '#F8BBD0',
      '#F48FB1',
      '#F06292',
      '#EC407A',
      '#E91E63',
      '#D81B60',
      '#C2185B',
      '#AD1457',
      '#880E4F',
      '#FF80AB',
      '#FF4081',
      '#F50057',
      '#C51162',
      '#9C27B0',
      '#F3E5F5',
      '#E1BEE7',
      '#CE93D8',
      '#BA68C8',
      '#AB47BC',
      '#9C27B0',
      '#8E24AA',
      '#7B1FA2',
      '#6A1B9A',
      '#4A148C',
      '#EA80FC',
      '#E040FB',
      '#D500F9',
      '#AA00FF',
      '#673AB7',
      '#EDE7F6',
      '#D1C4E9',
      '#B39DDB',
      '#9575CD',
      '#7E57C2',
      '#673AB7',
      '#5E35B1',
      '#512DA8',
      '#4527A0',
      '#311B92',
      '#B388FF',
      '#7C4DFF',
      '#651FFF',
      '#6200EA',
      '#3F51B5',
      '#E8EAF6',
      '#C5CAE9',
      '#9FA8DA',
      '#7986CB',
      '#5C6BC0',
      '#3F51B5',
      '#3949AB',
      '#303F9F',
      '#283593',
      '#1A237E',
      '#8C9EFF',
      '#536DFE',
      '#3D5AFE',
      '#304FFE',
      '#2196F3',
      '#E3F2FD',
      '#BBDEFB',
      '#90CAF9',
      '#64B5F6',
      '#42A5F5',
      '#2196F3',
      '#1E88E5',
      '#1976D2',
      '#1565C0',
      '#0D47A1',
      '#82B1FF',
      '#448AFF',
      '#2979FF',
      '#2962FF',
      '#03A9F4',
      '#E1F5FE',
      '#B3E5FC',
      '#81D4FA',
      '#4FC3F7',
      '#29B6F6',
      '#03A9F4',
      '#039BE5',
      '#0288D1',
      '#0277BD',
      '#01579B',
      '#80D8FF',
      '#40C4FF',
      '#00B0FF',
      '#0091EA',
      '#00BCD4',
      '#E0F7FA',
      '#B2EBF2',
      '#80DEEA',
      '#4DD0E1',
      '#26C6DA',
      '#00BCD4',
      '#00ACC1',
      '#0097A7',
      '#00838F',
      '#006064',
      '#84FFFF',
      '#18FFFF',
      '#00E5FF',
      '#00B8D4',
      '#009688',
      '#E0F2F1',
      '#B2DFDB',
      '#80CBC4',
      '#4DB6AC',
      '#26A69A',
      '#009688',
      '#00897B',
      '#00796B',
      '#00695C',
      '#004D40',
      '#A7FFEB',
      '#64FFDA',
      '#1DE9B6',
      '#00BFA5',
      '#4CAF50',
      '#E8F5E9',
      '#C8E6C9',
      '#A5D6A7',
      '#81C784',
      '#66BB6A',
      '#4CAF50',
      '#43A047',
      '#388E3C',
      '#2E7D32',
      '#1B5E20',
      '#B9F6CA',
      '#69F0AE',
      '#00E676',
      '#00C853',
      '#8BC34A',
      '#F1F8E9',
      '#DCEDC8',
      '#C5E1A5',
      '#AED581',
      '#9CCC65',
      '#8BC34A',
      '#7CB342',
      '#689F38',
      '#558B2F',
      '#33691E',
      '#CCFF90',
      '#B2FF59',
      '#76FF03',
      '#64DD17',
      '#CDDC39',
      '#F9FBE7',
      '#F0F4C3',
      '#E6EE9C',
      '#DCE775',
      '#D4E157',
      '#CDDC39',
      '#C0CA33',
      '#AFB42B',
      '#9E9D24',
      '#827717',
      '#F4FF81',
      '#EEFF41',
      '#C6FF00',
      '#AEEA00',
      '#FFEB3B',
      '#FFFDE7',
      '#FFF9C4',
      '#FFF59D',
      '#FFF176',
      '#FFEE58',
      '#FFEB3B',
      '#FDD835',
      '#FBC02D',
      '#F9A825',
      '#F57F17',
      '#FFFF8D',
      '#FFFF00',
      '#FFEA00',
      '#FFD600',
      '#FFC107',
      '#FFF8E1',
      '#FFECB3',
      '#FFE082',
      '#FFD54F',
      '#FFCA28',
      '#FFC107',
      '#FFB300',
      '#FFA000',
      '#FF8F00',
      '#FF6F00',
      '#FFE57F',
      '#FFD740',
      '#FFC400',
      '#FFAB00',
      '#FF9800',
      '#FFF3E0',
      '#FFE0B2',
      '#FFCC80',
      '#FFB74D',
      '#FFA726',
      '#FF9800',
      '#FB8C00',
      '#F57C00',
      '#EF6C00',
      '#E65100',
      '#FFD180',
      '#FFAB40',
      '#FF9100',
      '#FF6D00',
      '#FF5722',
      '#FBE9E7',
      '#FFCCBC',
      '#FFAB91',
      '#FF8A65',
      '#FF7043',
      '#FF5722',
      '#F4511E',
      '#E64A19',
      '#D84315',
      '#BF360C',
      '#FF9E80',
      '#FF6E40',
      '#FF3D00',
      '#DD2C00',
      '#795548',
      '#EFEBE9',
      '#D7CCC8',
      '#BCAAA4',
      '#A1887F',
      '#8D6E63',
      '#795548',
      '#6D4C41',
      '#5D4037',
      '#4E342E',
      '#3E2723',
      '#9E9E9E',
      '#FAFAFA',
      '#F5F5F5',
      '#EEEEEE',
      '#E0E0E0',
      '#BDBDBD',
      '#9E9E9E',
      '#757575',
      '#616161',
      '#424242',
      '#212121',
      '#607D8B',
      '#ECEFF1',
      '#CFD8DC',
      '#B0BEC5',
      '#90A4AE',
      '#78909C',
      '#607D8B',
      '#546E7A',
      '#455A64',
      '#37474F',
      '#263238',
      '#000000',
      '#FFFFFF',
    ],



  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ show: true })
    }, 10);

    this.createOptions()

  }

  componentDidUpdate(prevProps) {
    if (this.props.fields != prevProps.fields) {
      this.createOptions()
    }
  }

  createOptions = () => {
    let imageOptions = [{ title: '{{lang}}< Custom image >', 'value': '**custom' }]
    let videoOptions = [{ title: '{{lang}}< Custom image >', 'value': '**custom' }]

    let fields = this.props.fields
    let params = []

    // console.log(fields)
    // console.log('params,', this.props.params)


    if (fields) {
      fields.forEach(field => {
        if (field.type == 'ImageInput') {
          imageOptions.push({ title: field.information?.label, 'value': "{{" + field.key + "}}" })
        }

        if (field.type == 'VideoInput') {
          videoOptions.push({ title: field.information?.label, 'value': "{{" + field.key + "}}" })
        }

      });
    }


    if (this.props.params) {

      let choosen
      this.props.params.forEach(item => {
        let paramIsValid = false
        let validTypes = this.props.header.information?.validTypes ?? []

        if (item.fields) {
          item.fields.forEach(field => {

            if (validTypes.includes(field.type)) {

              if (!paramIsValid) {
                paramIsValid = true
                let param = { ...item }
                param.fields = []
                params.push(param)
              }
              let value = "{{" + checkTranslation(item.label) + ' - ' + checkTranslation(field.information?.label) + "}}"
              let title = checkTranslation(item.label) + ' - ' + checkTranslation(field.information?.label)


              // console.log(value)
              // console.log(this.props.data)

              if (value == this.props.data) {

                choosen = {
                  value: value,
                  title: title
                }
              }


              params[params.length - 1].fields.push(field)
            }
          });
        }
      })
    }

    // console.log(params)

    this.setState({ imageSourceOptions: imageOptions, videoSourceOptions: videoOptions })

  }

  setData = (key, value, myRef) => {
    if (myRef) {
      myRef.hideView()
    }

    this.props.setData(this.props.header?.id, key, value)
  }

  setElementSettings = (key, value) => {

    this.props.setElementSettings(this.props.index, key, value)

  }


  makeInvisible = () => {
    this.props.makeInvisible(this.props.header?.key, this.props.index)
  }

  changeSelectedTextEffects = (key, value, myRef) => {
    // "colorpicker"
    if (myRef) {
      myRef.hideView()
    }
    this.props.changeSelectedTextEffects({ effectType: key, value: value }, this.props.editorId)

  }

  // liveChange = (data, init, key, value, extra) => {

  //   this.props.setElementSettings(this.props.index, "information.action." + key, value)

  // }

  // this.props.setElementSettings(this.props.index, "information." + key, value)

  insertText = (text) => {
    // console.log('insertText', text)
    this.parametersView.hideView()
    // console.log(this.props.insertText)
    if (this.props.insertText) {
      this.props.insertText(text.replace('{{lang}}', ''), this.props.editorId)
    }
  }





  columnSettingsChange = (data, init, key, value, extra) => {

    if (!init) {
      this.props.setRowColSettings(this.props.index, key, value, "column")
    }
  }


  changeFileTypeValue = (key, value) => {
    // let myValue = value
    // if(value != '**custom' && value){
    //   value = '{{'+value+'}}'
    // }
    this.props.setElementSettings(this.props.index, 'source', value)
    // setTimeout(() => {
    //   this.setElementSettings('infomration.source', "variable")

    // }, 10);

  }


  onDrop = (files, withCompression) => {

    // console.log(files)
    // this.hideDropZone()
    // this.MessengerDropModal.showModal(files, withCompression)

    let filePath
    let showAlbum = false
    let view = 'file'
    files.forEach(element => {
      if (element.type.startsWith('image/') || element.type.startsWith('video/')) {
        showAlbum = true
      }
      filePath = URL.createObjectURL(element)
      console.log('filePath', filePath)

    });

    // if (withCompression) {
    //   view = 'album'
    // }
    HttpServices.addUploadQueque(files[0], {}, nanoid(), (image) => {
      this.props.setElementSettings(this.props.index, 'customImage', image.address)
      this.setState({ droppedFile: files[0], filePath, showAlbum })
    })


  }

  removeFromDroppedFiles = () => {
    this.setState({ droppedFile: null, filePath: null, showAlbum: false })

  }

  liveChange = (data, init, key, value, extra) => {

    this.props.setElementSettings(this.props.index, key, value)

  }


  render() {

    // console.log(this.props.element)
    let source = this.props.element?.information?.source//this.props.element?.information?.source

    let parents = this.props.section?.parents
    let column
    let row

    if (Array.isArray(parents)) {
      column = parents[parents.length - 1]
      row = parents[parents.length - 2]

    }


    return (


      <div>

        <div className='h-100   d-flex pb-2' style={{ position: 'absolute', bottom: -44, left: 0, zIndex: 1, alignItems: 'flex-end', pointerEvents: 'none' }} onClick={e => e.stopPropagation()}>
          <div className='card-options-container flexc back-blur flexc w-100 px-1'>
            <img onMouseDown={(e) => this.props.startMove(e)} draggable={false} {...this.props.provided?.dragHandleProps} src='/assets/icons/drag-and-drop.svg' height={14} className={"builder-options-icon px-1 " + (this.props.dontInvert ? '' : 'invert')} />

            {(this.props.section?.type != 'TextWidget' && this.props.section?.type != 'ImageWidget' && this.props.section?.type != 'VideoWidget') && (

              <img alt="" ref={(el) => (this.configBut = el)} onClick={(e) => this.props.showConfig(e)} src='/assets/icons/useful/settings.png' height={14} className={"builder-options-icon px-1 " + (this.props.dontInvert ? '' : 'invert')} />

            )}


            {this.props.section?.type == 'TextWidget' && (
              <>

                <img ref={(el) => (this.fontSizeBut = el)} onClick={() => this.fontSizeView.showView()} src='/assets/icons/builder/font-size.png' height={14} className={"builder-options-icon px-1 " + (this.props.dontInvert ? '' : 'invert')} />
                <img ref={(el) => (this.textColorBut = el)} onClick={() => this.textColorView.showView()} src='/assets/icons/builder/paint-bucket.png' height={14} className={"builder-options-icon px-1 " + (this.props.dontInvert ? '' : 'invert')} />
                <img ref={(el) => (this.textAlignBut = el)} onClick={() => this.fontSizeView.showView()} src='/assets/icons/builder/align-left.png' height={14} className={"builder-options-icon px-1 " + (this.props.dontInvert ? '' : 'invert')} />
                <img ref={(el) => (this.textWeightBut = el)} onClick={() => this.textWeightView.showView()} src='/assets/icons/builder/bold.png' height={14} className={"builder-options-icon px-1 " + (this.props.dontInvert ? '' : 'invert')} />

                <button ref={(el) => (this.parametersBut = el)} onClick={() => this.parametersView.showView()}>
                  <p className={"text-smaller builder-options-icon " + (this.props.dontInvert ? '' : 'invert')}>{translate("Params")}</p>
                </button>

              </>
            )}


            {/* {this.props.section?.type == 'ButtonWidget' && (
              <>
                <img ref={(el) => (this.actionsBut = el)} onClick={() => this.actionstView.open()} src='/assets/icons/builder/function.svg' height={14} className={"builder-options-icon px-1 " + (this.props.dontInvert ? '' : 'invert')} />
              </>
            )} */}

            {this.props.section?.type == 'VideoWidget' && (
              <>
                <img alt="" ref={(el) => (this.sourceSelectorBut = el)} onClick={() => this.videoSelector.showView()} src='/assets/icons/useful/gallery.png' height={14} className="builder-options-icon invert  mrd-3" />
                <img alt="" ref={(el) => (this.sizesBut = el)} onClick={() => this.sizesView.showView()} src='/assets/icons/useful/arrow.png' height={14} className="builder-options-icon invert  mrd-3" />
                {/* <img alt="" ref={(el) => (this.textAlignBut = el)} onClick={() => this.fontSizeView.showView()} src='/assets/icons/builder/align-left.png' height={14} className="builder-options-icon invert  mrd-3" /> */}
                <img alt="" ref={(el) => (this.textWeightBut = el)} onClick={() => this.textWeightView.showView()} src='/assets/icons/useful/filter 2.png' height={14} className="builder-options-icon invert  mrd-3" />

                {/* <img alt="" onClick={(e) => { e.stopPropagation(); this.doRemoveElement(e, section,) }} src='/assets/icons/useful/trash-o.svg' height={14} className="builder-options-icon invert  " /> */}

              </>

            )}



            {this.props.section?.type == 'ImageWidget' && (
              <>
                <img alt="" ref={(el) => (this.sourceSelectorBut = el)} onClick={() => this.imageSelector.showView()} src='/assets/icons/useful/gallery.png' height={14} className="builder-options-icon invert  mrd-3" />
                <img alt="" ref={(el) => (this.sizesBut = el)} onClick={() => this.sizesView.showView()} src='/assets/icons/useful/arrow.png' height={14} className="builder-options-icon invert  mrd-3" />
                {/* <img alt="" ref={(el) => (this.textAlignBut = el)} onClick={() => this.fontSizeView.showView()} src='/assets/icons/builder/align-left.png' height={14} className="builder-options-icon invert  mrd-3" /> */}
                <img alt="" ref={(el) => (this.textWeightBut = el)} onClick={() => this.textWeightView.showView()} src='/assets/icons/useful/filter 2.png' height={14} className="builder-options-icon invert  mrd-3" />

                {/* <img alt="" onClick={(e) => { e.stopPropagation(); this.doRemoveElement(e, section,) }} src='/assets/icons/useful/trash-o.svg' height={14} className="builder-options-icon invert  " /> */}

              </>

            )}

            <div className='mx-2' style={{ height: 16, width: 1, backgroundColor: this.props.dontInvert ? '#00000050' : '#ffffff50' }}>
            </div>
            {/* <img alt="" ref={(el) => (this.fieldLabelBut = el)} onClick={() => this.textWeightView.showView()} src='/assets/icons/builder/tag.png' height={14} className="builder-options-icon invert  mrd-3" /> */}
            {/* <img alt="" ref={(el) => (this.fieldIconBut = el)} onClick={() => this.textWeightView.showView()} src='/assets/icons/useful/key.png' height={14} className="builder-options-icon invert  mrd-3" /> */}



            {/* <button ref={(el) => (this.parametersBut = el)} onClick={() => this.parametersView.showView()} style={{background:'#000'}} className="br-20 px-2 py-1 text-semibold">
              <p className={"text-smaller builder-options-icon " + (this.props.dontInvert ? '' : 'invert')}>{translate("Element")}</p>
            </button> */}
            {/* <img alt="" ref={(el) => (this.rowSettingsBut = el)} onClick={() => this.columnSettingsView.showView()} src='/assets/icons/useful/row.png' height={14} className={"builder-options-icon   px-1 " + (this.props.dontInvert ? '' : 'invert')} /> */}

            <img alt="" ref={(el) => (this.columnSettingsBut = el)} onClick={() => this.columnSettingsView.showView()} src='/assets/icons/useful/column.png' height={14} className={"builder-options-icon   px-1 " + (this.props.dontInvert ? '' : 'invert')} />



            <img onClick={(e) => this.props.duplicateElement(e)} src='/assets/icons/useful/duplicate.svg' height={14} className={"builder-options-icon  px-1 " + (this.props.dontInvert ? '' : 'invert')} />

            <img onClick={(e) => this.props.doRemoveElement(e)} src='/assets/icons/useful/trash-o.svg' height={14} className={"builder-options-icon  px-1 " + (this.props.dontInvert ? '' : 'invert')} />

            {/* <img ref={(el) => (this.spacingBut = el)} onClick={() => this.fontSizeView.showView()} src='/assets/icons/builder/blank-space.png' height={14} className="builder-options-icon invert  " /> */}


            {/* <img src='/assets/icons/useful/row.png' height={14} className="builder-options-icon invert  mrd-2" />
                    <img src='/assets/icons/useful/column.png' height={14} className="builder-options-icon invert  mrd-2" /> */}

          </div>
        </div>

        {this.state.show && (
          <>



            <FixedView zIndex={10} ref={(el) => (this.videoSelector = el)} nodeRef={this.sizesBut} xOffset={44} bottomOffset={0} topOffset={10} maxWidth={300} width={300}    >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2" style={{ maxHeight: "250px", overflowY: "auto" }}   >


                  <div className="mb-1">
                    <div className="text-small mb-1 px-1 mt-1 required">
                      {translate("Just Show Cover")}
                    </div>
                    <div className="modern-input flexc ">
                      <SwitchInput data={this.props.element?.information?.showCover} header={{ key: 'showCover', information: { type: 'local' } }} changeValue={(key, value, extra) => { this.liveChange(null, false, key, value, extra) }} />
                    </div>
                  </div>


                  <div className="mb-1">
                    <div className="text-small mb-1 px-1 mt-1 required">
                      {translate("Video source")}
                    </div>
                    <div className="modern-input flexc ">
                      <ParamsInput data={source} params={this.props.params} fields={this.props.fields} header={{ key: '', information: { validTypes: ['VideoInput'], placeholder: '{{lang}}< Custom Source >', } }} changeValue={this.changeFileTypeValue} />

                      {/* <SelectInput data={source} header={{ key: '', information: { type: 'local', items: this.state.videoSourceOptions } }} changeValue={this.changeFileTypeValue} /> */}
                    </div>
                  </div>


                  {!this.state.filePath && (!source || source == '**custom') && (
                    <Dropzone
                      // disabled={this.props.disabled}
                      ref={el => this.dropzoneRef = el}
                      multiple={true}
                      // onDragLeave={this.hideDropZone}
                      accept='video/mp4'
                      onDrop={(e) => this.onDrop(e, false)}
                      // onDragOver={(e) => this.showDropZone(e, '2')}
                      style={{ flex: 1, cursor: 'pointer', outline: 'none' }}
                    >
                      {({ getRootProps, getInputProps }) => (

                        <div className=" w-100 flex-1 outline-none flexcc  pb-3 pt-2" {...getRootProps()} style={{ backgroundColor: '#fff' }}>
                          <input {...getInputProps()} />
                          <div className="w-100 h-100 flexcc flex-column px-3 py-4" style={{ border: '2px dashed #eee', borderRadius: 6, pointerEvents: 'none', backgroundColor: '#f6f6f6' }}>
                            <img className="" src={'/assets/icons/useful/clip.svg'} height={30} draggable={false} />
                            <p className="text-semibold text-small mt-2">{translate("Browes Files")}</p>
                            <p className="text-smaller mt-0 opacity-5">{translate("Or drop file here")}</p>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                  )}


                  {this.props.element?.information?.showCover && (
                    <div className="mb-1">
                      <div className="text-small mb-1 px-1 mt-1 required">
                        {translate("Show Duration")}
                      </div>
                      <div className="modern-input flexc ">
                        <SwitchInput data={this.props.element?.information?.showDuration} header={{ key: 'showDuration', information: { type: 'local', items: this.state.imageSourceOptions } }} changeValue={(key, value, extra) => { this.liveChange(null, false, key, value, extra) }} />
                      </div>
                    </div>
                  )}

                  {this.state.filePath && (!source || source == '**custom') && (
                    <div className="flexc  flex-wrap position-relative">
                      <img src={this.state.filePath} width={'100%'} className="br-6" style={{ border: '1px solid #f6f6f6' }} />

                      <div className="flexcc position-absolute py-1 px-1" style={{ zIndex: 1, right: 5, bottom: 5, backgroundColor: '#00000080', borderRadius: 8 }}>
                        <button className="flexcc p-0 mrd-1" onClick={() => this.removeFromDroppedFiles()}>
                          <img className=" invert hover-opacity transition-all" src={'/assets/icons/useful/crop.svg'} height={20} style={{}} />
                        </button>

                        <button className="flexcc p-0" onClick={() => this.removeFromDroppedFiles()}>
                          <img className=" invert hover-opacity transition-all" src={'/assets/icons/useful/trash-o.svg'} height={20} style={{}} />
                        </button>

                      </div>


                    </div>
                  )}

                  {!(!source || source == '**custom') && (
                    <p className="text-smallest mt-2 px-1 mb-2 color-gray-2">{translate("The image source will be automatically generated based on the image source which you have selected.")}</p>
                  )}

                </div>
              </div>
            </FixedView>





            <FixedView zIndex={10} ref={(el) => (this.imageSelector = el)} nodeRef={this.sizesBut} xOffset={44} bottomOffset={0} topOffset={10} maxWidth={300} width={300}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2" style={{ maxHeight: "250px", overflowY: "auto" }}   >

                  <div className="mb-1">
                    <div className="text-small mb-1 px-1 mt-1 required">
                      {translate("Image source")}
                    </div>
                    <div className="modern-input flexc ">
                      <ParamsInput data={source} params={this.props.params} fields={this.props.fields} header={{ key: '', information: { validTypes: ['ImageInput'], placeholder: '{{lang}}< Custom Source >', } }} changeValue={this.changeFileTypeValue} />

                      {/* <SelectInput data={source} header={{ key: '', information: { type: 'local', items: this.state.imageSourceOptions } }} changeValue={this.changeFileTypeValue} /> */}
                    </div>
                  </div>


                  {!this.state.filePath && (!source || source == '**custom') && (
                    <Dropzone
                      // disabled={this.props.disabled}
                      ref={el => this.dropzoneRef = el}
                      multiple={true}
                      // onDragLeave={this.hideDropZone}
                      accept='image/*'
                      onDrop={(e) => this.onDrop(e, false)}
                      // onDragOver={(e) => this.showDropZone(e, '2')}
                      style={{ flex: 1, cursor: 'pointer', outline: 'none' }}
                    >
                      {({ getRootProps, getInputProps }) => (

                        <div className=" w-100 flex-1 outline-none flexcc  pb-3 pt-2" {...getRootProps()} style={{ backgroundColor: '#fff' }}>
                          <input {...getInputProps()} />
                          <div className="w-100 h-100 flexcc flex-column px-3 py-4" style={{ border: '2px dashed #eee', borderRadius: 6, pointerEvents: 'none', backgroundColor: '#f6f6f6' }}>
                            <img className="" src={'/assets/icons/useful/clip.svg'} height={30} draggable={false} />
                            <p className="text-semibold text-small mt-2">{translate("Browes Files")}</p>
                            <p className="text-smaller mt-0 opacity-5">{translate("Or drop file here")}</p>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                  )}

                  {this.state.filePath && (!source || source == '**custom') && (
                    <div className="flexc  flex-wrap position-relative">
                      <img src={this.state.filePath} width={'100%'} className="br-6" style={{ border: '1px solid #f6f6f6' }} />

                      <div className="flexcc position-absolute py-1 px-1" style={{ zIndex: 1, right: 5, bottom: 5, backgroundColor: '#00000080', borderRadius: 8 }}>
                        <button className="flexcc p-0 mrd-1" onClick={() => this.removeFromDroppedFiles()}>
                          <img className=" invert hover-opacity transition-all" src={'/assets/icons/useful/crop.svg'} height={20} style={{}} />
                        </button>

                        <button className="flexcc p-0" onClick={() => this.removeFromDroppedFiles()}>
                          <img className=" invert hover-opacity transition-all" src={'/assets/icons/useful/trash-o.svg'} height={20} style={{}} />
                        </button>

                      </div>


                    </div>
                  )}

                  {!(!source || source == '**custom') && (
                    <p className="text-smallest mt-2 px-1 mb-2 color-gray-2">{translate("The image source will be automatically generated based on the image source which you have selected.")}</p>
                  )}

                </div>
              </div>
            </FixedView>


            <FixedView zIndex={10} ref={(el) => (this.sizesView = el)} nodeRef={this.sourceSelectorBut} xOffset={-10} bottomOffset={0} topOffset={10} maxWidth={300} width={300}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column w-100 px-1 py-2" >

                    <FormViewer ref={el => this.form = el} initData={this.props.element?.information} headers={this.state.sizesFields} formClass="modern" inputClass={'modern-input'} nopadding={true} liveChange={this.liveChange} width={this.props.width} />

                  </div>
                </div>
              </div>
            </FixedView>








            <FixedView zIndex={10} ref={(el) => (this.textWeightView = el)} nodeRef={this.textWeightBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={120} width={120}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2 w-100" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column ">

                  </div>
                </div>
              </div>
            </FixedView>





            <FixedView zIndex={10} ref={(el) => (this.fontSizeView = el)} nodeRef={this.fontSizeBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={40} width={100}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column ">
                    {this.state.fontsize.map((prop, index) => {
                      return (
                        <div className="bb-gray" key={index}>
                          {/* <button onClick={() => this.setData('fontSize', prop.type, this.fontSizeView)} className="px-1 py-1 my-1 br-5 w-100 hover-gray"> */}
                          <button onClick={() => this.changeSelectedTextEffects('fontSize', prop.type + 'px', this.fontSizeView)} className="px-1 py-1 my-1 br-5 w-100 hover-gray">

                            <p className="text-left">  {checkTranslation(prop.type)}   </p>
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </FixedView>



            <FixedView zIndex={10} ref={(el) => (this.textColorView = el)} nodeRef={this.textColorBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={300} width={300}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2" style={{ maxHeight: "250px", overflowY: "auto" }}   >

                  <button className="flexc mb-1 px-1" onClick={() => this.setData('textColor', null, this.textColorView)} >
                    <img src="/assets/icons/builder/color-palette.png" height={12} />
                    <p className="text-smaller px-1 text-semibold">{translate("Reset Color")}</p>
                  </button>

                  <div className="flexc  flex-wrap">
                    {this.state.colors.map((prop, index) => {
                      let color = prop
                      return (
                        <div className="color-picker-hover p-1 br-4 flexcc">
                          <button onClick={() => this.changeSelectedTextEffects('color', color, this.textColorView)} className="flexcc" style={{ height: 22, width: 22 }}>
                            <div className="br-20" style={{ background: color, height: 20, width: 20, border: chooseFontColor(color) != '#fff' ? '1px solid #eee' : '1px solid transparent' }}>

                            </div>
                          </button>
                        </div>
                      );
                    })}

                  </div>

                  <div className="w-100 mt-1 px-1 py-1" style={{ borderTop: '1px solid #eee' }}>
                    <button className="pt-2 pb-1 " >
                      <p className="text-smaller text-semibold">{translate("Conditional Formatting")}</p>
                    </button>
                  </div>
                </div>
              </div>
            </FixedView>




            <FixedView zIndex={10} ref={(el) => (this.textWeightView = el)} nodeRef={this.textWeightBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={120} width={120}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2 w-100" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column ">
                    {this.state.fontWeights.map((prop, index) => {
                      return (
                        <div className="bb-gray w-100">
                          {/* <button onClick={() => this.setData('fontWeight', prop.value, this.textWeightView)} className="px-1 py-1 my-1 br-5 w-100 hover-gray"> */}
                          <button onClick={() => this.changeSelectedTextEffects('fontWeight', prop.value, this.textWeightView)} className="px-1 py-1 my-1 br-5 w-100 hover-gray">
                            <p className="text-left">  {checkTranslation(prop.lable)}</p>
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </FixedView>




            <SidebarView width={this.props.width} zIndex={999} ref={el => this.actionstView = el} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '35%', lg: "35%", xl: "25%" }}>
              <div className="scroll-no-scrollbar h-100 white-bg" style={{ backgroundColor: '#fff' }} onClick={(e) => e.stopPropagation()}>
                <div className='px-2 py-2 w-100 flexcb'>
                  <p>Actions List</p>
                </div>
                <FormViewer ref={el => this.form = el} initData={this.props.element?.information} liveChange={this.liveChange} headers={this.state?.actionHeader} formClass="modern" inputClass={'modern-input'} width={this.props.width} />
              </div>
            </SidebarView>
            {/* <FixedView zIndex={10} ref={(el) => (this.actionstView = el)} nodeRef={this.actionsBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={120} width={120}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2 w-100" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column ">
                    {this.state.fontWeights.map((prop, index) => {
                      return (
                        <div className="bb-gray w-100">
                          <button onClick={() => this.changeSelectedTextEffects('fontWeight', prop.value, this.textWeightView)} className="px-1 py-1 my-1 br-5 w-100 hover-gray">
                            <p className="text-left">  {checkTranslation(prop.lable)}</p>
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </FixedView> */}




            <FixedView zIndex={10} ref={(el) => (this.parametersView = el)} nodeRef={this.parametersBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={170} width={170}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2 w-100" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column ">

                    {/* <div className="w-100 flexc px-1">
                      <p className="text-smaller text-bold">{translate("Variables")}</p>
                    </div> */}


                    <div className=' pb-2  w-100' >
                      {/* {console.log('this.props.params',this.props.params)} */}
                      {(!this.props.params || this.props.params.length == 0) && (
                        <div className="text-center pt-2">
                          <p className="text-small">{translate("No dynamic params")}</p>
                          <button className="text-smallest" style={{ color: '#007aff' }}>{translate("Learn more about dynamic params")}</button>
                        </div>
                      )}
                      {this.props.params?.map((item, index) => {
                        return (
                          <div className=" pt-2 pb-2 w-100 " key={item?.value} style={{ borderBottom: '1px solid #eee' }}>
                            <div className="px-1">
                              <p draggable={false} className=" text-bold text-small">{translate(item?.label)}</p>
                            </div>

                            {item?.fields?.map((field, index) => {
                              if (field.type != 'ImageInput' && field.type != 'FileInput' && field.type != 'VideoInput')
                                return (

                                  <button className=" flexcb w-100 text-smaller text-start mt-2" style={{ cursor: 'pointer', }} onClick={() => { this.insertText("{{" + item.label + ' - ' + field.information?.label + "}}") }}>
                                    <div className='flexc'>
                                      <img draggable={false} src={FormBuilderObjects[field.type]?.icon} className='br-20 mrd-3' height={20} style={{ filter: 'grayscale(0%)' }} />
                                      <p draggable={false} className=" text-semibold text-smaller">{translate(field.information?.label)}</p>
                                    </div>

                                    <img src='/assets/icons/drag-and-drop.svg' height={15} className='flexcc opacity-2 ' />

                                  </button>
                                )
                            })}

                          </div>
                        );
                      })}

                    </div>


                  </div>
                </div>
              </div>
            </FixedView>






            <FixedView zIndex={10} ref={(el) => (this.columnSettingsView = el)} nodeRef={this.columnSettingsBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={300} width={300}  >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column w-100 px-1 py-2" >

                    <FormViewer ref={el => this.form = el} initData={column} headers={this.state.columnSettingsFields} formClass="bordered-form" inputClass={'bordered-input'} nopadding={true} liveChange={this.columnSettingsChange} width={this.props.width} />

                  </div>
                </div>
              </div>
            </FixedView>



          </>
        )
        }
      </div>

    );
  }
}

export default MainComponentFloatConfig;
